import { openNewTab, isLocalUrl } from '../utils';

export default function customTicketButton() {
  const widgetName = 'customTicketButton';
  const widgetOpts = customTicketButtonOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 2,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomTicketBtn(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const items = widgetData.items.slice(0, 2);

    if (items.every((item) => item.URL == null)) {
      $widget.remove();
      $('body').addClass(`${widgetName}-no-data`);
    } else {
      const buttons = items
        .filter((item) => item.URL != null)
        .map(({ Title, URL }) => {
          const isLocal = isLocalUrl(URL);
          const targetElement = openNewTab(isLocal);
          return `<a class="button ticket-btn" tabindex="0" href="${URL}" ${targetElement}><i></i> ${Title}</a>`;
        })
        .join('');
      $widget.empty().append(buttons);
    }
  }
}
